import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { PixTransferSuccess } from '../../components/PixTransferSuccess/PixTransferSuccess';
export function PixTransferSuccessPage() {
    const location = useLocation();
    const state = location.state;
    if (!state?.pixData && !state?.scheduledData) {
        return _jsx(Navigate, { to: '/conta-pj/pix', replace: true });
    }
    return (_jsx(PixTransferSuccess, { pixData: state.pixData, scheduledData: state.scheduledData, transferData: state.transferData }));
}
